import { Attributes, Misc, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class CostRecoveryPremium extends ModelBase {
    static typeName = "CostRecoveryPremium";

    public costRecoveryPremiumId: number = 0;

    @Attributes.Float()
    @Attributes.Display("Cost Recovery Premium")
    public costRecoveryPremiumValue: number = 0;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public premiumStartDate: Date | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
        rules.failWhen(c => c.costRecoveryPremiumValue < 0, "Premiums cannot be negative.");
    }

    public toString(): string {
        if (this.isNew) {
            return "New cost recovery premium";
        } else {
            return "Cost Recovery Premium";
        }
    }
}